/**
 * Minimum agreement rate is now obtained from the `getMinimumAgreementRate` query.
 * This is used purely as a failsafe for when the API call fails.
 */
export const OLD_MINIMUM_AGREEMENT_RATE = 38;
export const NEW_MINIMUM_AGREEMENT_RATE = 39;
